import type { ValueOf } from '@weft/utils';
import { oz } from '@weft/utils';

export const NEST_API_TAGS = Object.freeze({
  AUTH: 'auth',
  EVENTS: 'events',
  CUSTOMERS: 'customers',
  CUSTOMER: 'customer',
  METERS: 'meters',
  PLANS: 'plans',
  CONTRACTS: 'contracts',
  CONTRACT: 'contract',
  INVOICES: 'invoices',
  INVOICE: 'invoice',
  BILLING_CYCLES: 'billing-cycles',
  REPORTS: 'reports',
  REPORT: 'report',
  DATA_DASHBOARD: 'data-dashboard',
  INTEGRATIONS: 'integrations',
  PAGES: 'pages',
  CREDIT_LEDGER: 'credit-ledger',
  EVENT_FIELDS: 'event-fields',
  LINE_ITEM: 'line-item',
  REVISIONED_LINE_ITEM: 'revisioned-line-item',
  MEASUREMENTS: 'measurements',
  NOTIFICATION_ALERTS: 'notification-alerts',
  PAYMENTS: 'payments',
  ACCOUNTS: 'accounts',
  CONTACT_US: 'contact-us',
  USERS: 'users',
});

export const NestApiTagSchema = oz.nativeEnum(NEST_API_TAGS);

export const NEST_API_TAG_VALUES = Object.values(NEST_API_TAGS);

export type NestApiTag = ValueOf<typeof NEST_API_TAGS>;
